import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'

import { SwpppPublicReport } from '../../shared'
import { Services } from '../../shared/services'

@Component({
    selector: 'app-swppp-public-action',
    templateUrl: './swppp-public-action.component.html',
    standalone: true,
    imports: [FormsModule],
})
export class SwpppPublicActionComponent implements OnInit {
    report?: SwpppPublicReport
    missing = false
    token = ''
    name = ''
    signature = ''

    constructor(
        private route: ActivatedRoute,
        private services: Services,
    ) {}

    ngOnInit() {
        this.token = this.route.snapshot.paramMap.get('token') || ''
        this.services.data.get<SwpppPublicReport>('/api/SwpppPublic/GetActions?token=' + this.token).subscribe({
            next: report => (this.report = report),
            error: () => (this.missing = true),
        })
    }

    signOff(actionItemId: string) {
        this.services.data
            .post('/api/SwpppPublic/SignOffAction', {
                token: this.token,
                actionItemId,
                completedByName: this.name,
                signature: this.signature,
            })
            .subscribe(() => this.ngOnInit())
    }
}
